import Skeleton from "@mui/material/Skeleton";

export default function TableSkeleton({ rows, columns }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex}>
              <Skeleton animation="wave" height={20} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}